import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";

const CommentSection = () => {
  const [comments, setComments] = useState([]);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Load Comments
  useEffect(() => {
    const q = query(
      collection(db, "comments"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setComments(data);
    });

    return () => unsubscribe();
  }, []);

  // Add Comment
  const addComment = async (e) => {
    e.preventDefault();

    if (name.trim() === "" || message.trim() === "") {
      alert("Please enter name and comment.");
      return;
    }

    try {
      setLoading(true);

      await addDoc(collection(db, "comments"), {
        name,
        message,
        createdAt: serverTimestamp(),
      });

      setName("");
      setMessage("");
    } catch (error) {
      console.log(error);
      alert("Failed to post comment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-2">
      <div className="row justify-content-center">
        <div className="col-lg-8">

          <div className="card shadow border-0">

            <div className="card-header bg-secondary text-white">
              <h4 className="mb-0">💬 Comments</h4>
            </div>

            <div className="card-body">

              <form onSubmit={addComment}>

                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Write your comment..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                <button
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? "Posting..." : "Post Comment"}
                </button>

              </form>

            </div>
          </div>

          <div className="mt-4">

            <h5 className="mb-3">
              Total Comments ({comments.length})
            </h5>

            {comments.length === 0 ? (
              <div className="alert alert-light border">
                No comments yet.
              </div>
            ) : (
              comments.map((comment) => (
                <div
                  className="card shadow-sm mb-3"
                  key={comment.id}
                >
                  <div className="card-body">

                    <div className="d-flex justify-content-between">

                      <strong>
                        👤 {comment.name}
                      </strong>

                      <small className="text-muted">
                        {comment.createdAt
                          ? comment.createdAt
                              .toDate()
                              .toLocaleString("en-IN")
                          : "Just Now"}
                      </small>

                    </div>

                    <hr />

                    <p className="mb-0">
                      {comment.message}
                    </p>

                  </div>
                </div>
              ))
            )}

          </div>

        </div>
      </div>
    </div>
  );
};

export default CommentSection;